import { useQuery } from "@apollo/client";
import CurrentUserData from "../../../queries/CurrentUserData.js";
import Spinner from "../../../components/Spinner.jsx";
// core components
import UserSurvey from "../../../components/UserSurvey.js";

const Survey = (props) => {
  console.log("Survey props:", props);
  const { loading, error, data } = useQuery(CurrentUserData);

  if (loading) return <Spinner />;
  if (error) {
    console.log("error:");
    console.log(error);
    return <p>Something Went Wrong...</p>;
  }

  const { currentUserData } = data;

  return <UserSurvey currentUserData={currentUserData} />;
};

export default Survey;
